import React, { useEffect, useState } from 'react'
import MsgUtils from '../Tools/MsgUtils';
import ConsultasComunes from '../Sql/ConsultasComunes';

function ColaboradorTelegram(props) {
    const { regional,collback } = props;
    const [colaboradores,setColaboradores] = useState([]);
    const obtenerColaboradores=async()=>{
        try {
            var result = await ConsultasComunes.getColaboradoreTelegram({regional})
            if(result.ok){
                setColaboradores(result.ok);
            }else{
                MsgUtils.msgError(result.error)
            }
        } catch (error) {
            MsgUtils.msgError(error.message);
        }
    }
    useEffect(()=>{
        obtenerColaboradores()
    },[])
    return (
        <div className='container-fluid'>
            <div className='text-light fw-bold'>Seleccione un Colaborador</div>
            <div className='overflow-auto' style={{maxHeight:'310px'}}>
                {colaboradores.map((item,index)=>{
                    return(
                        <div className='w-100 mb-1' key={index}>
                            <button className='btn btn-sm btn-dark bg-gradient w-100'
                                title={`${item.NOMBREX}`}
                                onClick={()=>collback(item)}>
                                <div className='text-light lh-1'>
                                    <div>{item.NOMBREX}</div>
                                    <div>Sucursal: {item.SUCURSAL}</div>
                                </div>
                            </button>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default ColaboradorTelegram